import { Badge } from '@mantine/core';
import { IconAlertTriangle, IconShieldCheck } from '@tabler/icons-react';

export interface SpamScoreChipProps {
  /** Whether the message is currently flagged as spam. */
  isSpam: boolean;
  /** Raw spam score in the [0, 1] range (higher = more spammy). */
  score: number;
}

/**
 * Renders the spam score with an icon disambiguating polarity
 * (higher score = more spammy). Color is driven by `isSpam`, the
 * authoritative spam decision, not the raw score.
 */
export function SpamScoreChip({ isSpam, score }: SpamScoreChipProps) {
  // Guard against NaN/Infinity and clamp to [0, 1] before mapping to a percentage.
  const safeScore = Number.isFinite(score) ? Math.min(Math.max(score, 0), 1) : 0;
  const display = Math.round(safeScore * 100);
  const color = isSpam ? 'red' : 'green';
  const Icon = isSpam ? IconAlertTriangle : IconShieldCheck;
  return (
    <Badge color={color} variant="light" leftSection={<Icon size={14} />}>
      {display}
    </Badge>
  );
}
